import { useCallback, useState } from 'react';
import { Button } from '@/components/button';
import { Input } from '@/components/input';

interface CreateRuleGroupProps {
  onSubmit?: (ruleGroup: { name: string; description?: string }) => Promise<void>;
}

const CreateRuleGroupForm = ({ onSubmit }: CreateRuleGroupProps) => {
  const [newRuleGroup, setNewRuleGroup] = useState({
    name: '',
    // description: '',
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setSaving(true);
      await onSubmit?.(newRuleGroup);
      setNewRuleGroup({
        name: '',
        //   description: '',
      });
      setSaving(false);
    },
    [newRuleGroup, onSubmit]
  );

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-4">
        <Input
          id="groupName"
          placeholder="Rule Group Name"
          className="flex-grow"
          value={newRuleGroup.name}
          onChange={(e) => setNewRuleGroup({ ...newRuleGroup, name: e.target.value })}
          required
        />
        {/* <Input
          id="description"
          placeholder="Description (Optional)"
          className="flex-grow"
          value={newRuleGroup.description}
          onChange={(e) => setNewRuleGroup({ ...newRuleGroup, description: e.target.value })}
        /> */}
      </div>
      <div className="flex flex-row justify-end mt-4">
        <Button type="submit" loading={saving}>
          Create
        </Button>
      </div>
    </form>
  );
};

export default CreateRuleGroupForm;
